"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-54ca7c7c"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "main-settings-container" };
const _hoisted_2 = { class: "settings-card-container" };
const _hoisted_3 = { class: "settings-title-wrapper" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "CSV文字コード", -1 /* HOISTED */));
const _hoisted_5 = { class: "settings-item browser-settings-item" };
const _hoisted_6 = { class: "flex-center" };
const _hoisted_7 = { class: "oplus-form-radio" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_9 = { class: "flex-center" };
const _hoisted_10 = { class: "oplus-form-radio" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_12 = { class: "flex-center" };
const _hoisted_13 = { class: "oplus-form-radio" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_15 = { class: "flex-center" };
const _hoisted_16 = { class: "oplus-form-radio" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_18 = { class: "settings-card-container" };
const _hoisted_19 = { class: "settings-title-wrapper" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, " シフト管理 ", -1 /* HOISTED */));
const _hoisted_21 = { class: "settings-item" };
const _hoisted_22 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "キャッシュを削除", -1 /* HOISTED */));
const _hoisted_24 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper last-tooltip" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "ブラウザに保存されているシフト管理ページの古いデータ（シフト・ユーザー情報）を削除します。")
], -1 /* HOISTED */));
const _hoisted_26 = { class: "settings-submit-button-wrapper" };
const CSVIcon_vue_1 = __importDefault(require("../icons/CSVIcon.vue"));
const ShiftManagementIcon_vue_1 = __importDefault(require("../icons/ShiftManagementIcon.vue"));
const vue_3 = require("vue");
const settings_1 = require("../../js/settings");
const IndexedDBStorage_1 = require("../../storage/IndexedDBStorage");
const storageSummary_1 = require("../../storage/storageSummary");
const InfoIcon_vue_1 = __importDefault(require("../icons/InfoIcon.vue"));
const common_1 = require("../../common/common");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SettingsBrowserContent',
    setup(__props, { expose: __expose }) {
        const isLoading = (0, vue_3.ref)(false);
        const encodings = (0, vue_3.ref)("0");
        const savedEncoding = (0, vue_3.ref)("0");
        async function submitBrowserSettings() {
            if (isLoading.value) {
                return false;
            }
            try {
                isLoading.value = true;
                (0, settings_1.setCSVEncoding)(parseInt(encodings.value, 10));
                // since changing browser settings is likely instant (just updating local storage) we intentionally delay it to simulate async submit
                await new Promise(resolve => setTimeout(resolve, 300));
                savedEncoding.value = encodings.value;
                (0, common_1.showSaveSuccessSnackbar)();
                return true;
            }
            catch (err) {
                (0, settings_1.importAlertModal)().alert(err);
                return false;
            }
            finally {
                isLoading.value = false;
            }
        }
        const loadingClass = (0, vue_3.computed)(() => {
            return {
                "loading": isLoading.value,
            };
        });
        async function handleClearSummaryPageCache() {
            const databases = await indexedDB.databases();
            for (const d of databases) {
                if (d.name === storageSummary_1.summaryDb) {
                    try {
                        const db = new IndexedDBStorage_1.IndexedDBStorage(storageSummary_1.summaryDb);
                        await db.clearAllStores();
                        db.close();
                        break;
                    }
                    catch (e) {
                        console.log(e);
                        alert("キャッシュを削除できませんでした。");
                        return;
                    }
                }
            }
            (0, settings_1.importAlertModal)().alertSuccess("シフト管理ページのキャッシュを削除しました！");
        }
        function hasUnsavedChanges() {
            return encodings.value !== savedEncoding.value;
        }
        __expose({
            hasUnsavedChanges,
            saveSettings: submitBrowserSettings,
        });
        (0, vue_3.onMounted)(() => {
            const currentEncoding = (0, settings_1.getCSVEncoding)();
            encodings.value = currentEncoding;
            savedEncoding.value = currentEncoding;
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createCommentVNode)(" Browser settings "),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)(CSVIcon_vue_1.default, { class: "page-title-text" }),
                        _hoisted_4
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            (0, vue_2.createElementVNode)("label", _hoisted_7, [
                                (0, vue_2.createTextVNode)(" UTF-8 BOM － Windows Excel "),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((encodings).value = $event)),
                                    value: "0",
                                    type: "radio",
                                    name: "csv-browser-settings"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelRadio, encodings.value]
                                ]),
                                _hoisted_8
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createElementVNode)("label", _hoisted_10, [
                                (0, vue_2.createTextVNode)(" UTF-8 BOMなし － MacOS Excel "),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((encodings).value = $event)),
                                    value: "1",
                                    type: "radio",
                                    name: "csv-browser-settings"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelRadio, encodings.value]
                                ]),
                                _hoisted_11
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_12, [
                            (0, vue_2.createElementVNode)("label", _hoisted_13, [
                                (0, vue_2.createTextVNode)(" Windows 31J － Windows Excel \"Ansi\" "),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((encodings).value = $event)),
                                    value: "2",
                                    type: "radio",
                                    name: "csv-browser-settings"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelRadio, encodings.value]
                                ]),
                                _hoisted_14
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_15, [
                            (0, vue_2.createElementVNode)("label", _hoisted_16, [
                                (0, vue_2.createTextVNode)(" UTF-16 LE － Windows Unicode "),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((encodings).value = $event)),
                                    value: "3",
                                    type: "radio",
                                    name: "csv-browser-settings"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelRadio, encodings.value]
                                ]),
                                _hoisted_17
                            ])
                        ])
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_18, [
                    (0, vue_2.createElementVNode)("div", _hoisted_19, [
                        (0, vue_2.createVNode)(ShiftManagementIcon_vue_1.default, { class: "page-title-text" }),
                        _hoisted_20
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_21, [
                        (0, vue_2.createElementVNode)("div", _hoisted_22, [
                            _hoisted_23,
                            (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                _hoisted_25
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("label", { class: "settings-input oplus-form-switch" }, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "oplus-modal-btn oplus-confirm-btn clear-btn",
                                onClick: handleClearSummaryPageCache
                            }, "削除")
                        ])
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_26, [
                    (0, vue_2.createElementVNode)("button", {
                        class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn oplus-save-btn", loadingClass.value]),
                        onClick: submitBrowserSettings
                    }, "変更を保存", 2 /* CLASS */)
                ])
            ]));
        };
    }
});
